import styled from '@emotion/styled';

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
`;
